"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeGuards = require("../../libs/typeGuards");

var _Edit = _interopRequireDefault(require("@insided/shared/icons/Edit"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var TitleInput = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TitleInput, _Component);

  var _super = _createSuper(TitleInput);

  function TitleInput(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TitleInput);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "titleInputRef", null);
    _this.state = {
      showTitleInput: false
    };
    return _this;
  }

  (0, _createClass2.default)(TitleInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      document.addEventListener('mousedown', function (e) {
        return _this2.onClickOutsideOfTitle(e);
      });
      document.addEventListener('keypress', function (e) {
        return _this2.onPressEnterInTitle(e);
      });
    }
  }, {
    key: "onTitleClicked",
    value: function onTitleClicked() {
      var _this3 = this;

      this.setState({
        showTitleInput: true
      }, function () {
        if (_this3.titleInputRef) {
          _this3.titleInputRef.focus();
        }
      });
    }
  }, {
    key: "onClickOutsideOfTitle",
    value: function onClickOutsideOfTitle(e) {
      if (this.titleInputRef && !this.titleInputRef.contains(e.target)) {
        this.titleInputRef.blur();
        this.setState({
          showTitleInput: false
        });
      }
    }
  }, {
    key: "onPressEnterInTitle",
    value: function onPressEnterInTitle(e) {
      if (this.titleInputRef && e.keyCode === 13) {
        this.titleInputRef.blur();
        this.setState({
          showTitleInput: false
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          title = _this$props.title,
          onTitleChanged = _this$props.onTitleChanged,
          placeholder = _this$props.placeholder;

      if (this.state.showTitleInput) {
        return (0, _preact.h)("div", {
          className: "title-input"
        }, (0, _preact.h)("input", {
          className: "qa-title-input form-control",
          type: "text",
          value: title,
          required: true,
          onChange: function onChange(e) {
            if ((0, _typeGuards.hasValueInEventTarget)(e)) {
              onTitleChanged(e.target.value.trim());
            }
          },
          maxLength: 250,
          ref: function ref(titleInput) {
            _this4.titleInputRef = titleInput;
          }
        }));
      }

      return (0, _preact.h)("div", {
        className: "title-input"
      }, (0, _preact.h)("div", {
        className: "title-input__title",
        onClick: function onClick() {
          return _this4.onTitleClicked();
        }
      }, (0, _preact.h)("h2", {
        className: "control-header__title qa-title-text"
      }, placeholder && title.length === 0 ? (0, _preact.h)("span", {
        className: "title-input__title--placeholder"
      }, placeholder) : title, (0, _preact.h)(_Edit.default, {
        width: 20,
        height: 20
      }))));
    }
  }]);
  return TitleInput;
}(_preact.Component);

var _default = TitleInput;
exports.default = _default;